module.exports = {};



//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_iterators.js
// module id = 43
// module chunks = 0